import { Directive, ElementRef, Input, OnDestroy, OnInit } from "@angular/core"
import { StickyNavbarTrigger } from "./sticky-navbar.model"
import { StickyNavbarService } from "./sticky-navbar.service"

@Directive({
    selector: "[appStickyNavbarTrigger]",
    standalone: false,
})
export class StickyNavbarTriggerDirective implements OnInit, OnDestroy, StickyNavbarTrigger {
    @Input() triggerId: string

    constructor(
        public triggerElementRef: ElementRef,
        private stickyNavbarService: StickyNavbarService
    ) {}

    public ngOnInit() {
        this.stickyNavbarService.registerTrigger(this)
    }

    public ngOnDestroy() {
        this.stickyNavbarService.deregisterTrigger(this)
    }
}
